// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__pQN7C","large":"styles_large__3VL83"};